<script>
  export let json = {}
  export let namespace = ""
</script>

{#each Object.entries(json) as [key, value]}
  <div class="border border-transparent pl-6 ring-1 ring-transparent" id={typeof value == "object" ? key : `preview_${namespace ? namespace + "." + key : key}`}>
    {#if typeof value == "object"}
      <div class="mb-3">
        <h1 class="text-2xl font-medium capitalize text-gray-800 dark:text-gray-200">{key}</h1>
      </div>
    {/if}
    {#if typeof value == "object"}
      <svelte:self json={value} namespace={key} />
    {:else}
      <div class="pb-3">
        <h2 class="text-sm font-normal capitalize text-gray-300 dark:text-white">{key}</h2>
        <h3 class="dark:text-=gray-200 break-words pr-3 text-lg font-medium text-gray-900 dark:text-gray-200">
          {value ? value : "Sample Value(empty)"}
        </h3>
      </div>
    {/if}
  </div>
{/each}

<style lang="postcss" global>
  .active-select {
    @apply -mr-3 -mt-1.5 ml-3 rounded-md bg-sky-200/40 pl-3 pt-1.5;
  }
  .namespace-bold {
    @apply font-bold text-blue-500;
  }

  .active-border {
    @apply mb-3 mr-3 rounded-md border border-blue-500 pt-1 ring-1 ring-blue-500;
  }
</style>
